import { useEffect } from 'react'
import { useStore } from '@/store/useStore'

/** App-wide toast for {@link useStore.showSaveToast} (e.g. brief Push on /upcoming). */
export default function SaveToastHost() {
  const saveToast = useStore((s) => s.saveToast)
  const clearSaveToast = useStore((s) => s.clearSaveToast)

  useEffect(() => {
    if (!saveToast) return undefined
    const timeoutId = window.setTimeout(() => {
      clearSaveToast(saveToast.id)
    }, 5000)
    return () => window.clearTimeout(timeoutId)
  }, [clearSaveToast, saveToast])

  if (!saveToast) return null

  const tone =
    saveToast.kind === 'success'
      ? 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-200'
      : 'border-red-200 bg-red-50 text-red-800 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-200'

  return (
    <div
      role="status"
      className={`pointer-events-none fixed right-4 top-4 z-[100] max-w-sm rounded-xl border px-4 py-3 text-sm font-semibold shadow-lg ${tone}`}
    >
      {saveToast.message}
    </div>
  )
}
